import styled from "styled-components"


export const EditorGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`

interface SpacerProps {
  $width?: string
  $height?: string
}
export const Spacer = styled.div<SpacerProps>`
  flex-shrink: 0;
  width: ${(props) => (props.$width ?? '5px')};
  height: ${(props) => (props.$height ?? '5px')};
`
export const Label = styled.label`
  display: block;
  font-weight: lighter;
  color: var(--label-color);
  padding-bottom: 2px;
`;
export const Sublabel = styled.label`
  opacity: 75%;
  display: block;
  font-weight: lighter;
  font-size: 0.85rem;
  color: var(--label-color);
  padding-bottom: 2px;
`;

export const Expanding = styled.div`
  flex-grow: 1;
`;

export const NameInput = styled.input`
  flex-grow: 1;
  padding: 0.25rem; /* Equivalent to p-2 */
  border: 1px solid var(--border-color); 
  border-radius: 0.25rem;
`;


